export default function percent(value, decimals) {
    if (!value || value === null) {
        return '';
    }

    decimals = decimals || 2;

    // percent is measured by numbers from 0 to 1 as 0% to 100%
    const valueToParse = Number.parseFloat(value) / 100;

    return Number.parseFloat(valueToParse).toLocaleString('en-GB', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: decimals
    });
}
